import { InvestmentType } from '@stashinvest/product-events-javascript/lib/enum_properties';

export const ETF = 'ETF';
export const STOCK = 'STOCK';
export const COIN = 'COIN';

// These are technically ETFs in the system but they need to be handled
// differently when buying and selling.
export const CRYPTO_TRUSTS = ['GBTC', 'ETHE'];

export const ANALYTICS_INVESTMENT_TYPE = {
	[ETF]: InvestmentType.etf,
	[STOCK]: InvestmentType.stock,
};
